module.exports = __webpack_public_path__ + "static/img/winters-quirrel-cup.0cc97825.png";